package one.healthium.uscreen.serialization

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.descriptors.buildClassSerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonEncoder
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.serialization.json.put
import one.healthium.uscreen.domain.models.CtaAction

object CtaActionSerializer : KSerializer<CtaAction> {
    override val descriptor: SerialDescriptor =
        buildClassSerialDescriptor("one.healthium.uscreen.domain.models.CtaAction") {}

    override fun deserialize(decoder: Decoder): CtaAction {
        val input = decoder as JsonDecoder
        return when (val element = input.decodeJsonElement()) {
            is JsonPrimitive -> fromString(element.content)
            is JsonObject -> fromObject(element)
            else -> CtaAction.Next
        }
    }

    override fun serialize(encoder: Encoder, value: CtaAction) {
        val output = encoder as JsonEncoder
        output.encodeJsonElement(value.toJsonElement())
    }

    private fun fromString(value: String): CtaAction = when (value) {
        "next" -> CtaAction.Next
        "back" -> CtaAction.Back
        "sign_in" -> CtaAction.SignIn
        "restore" -> CtaAction.Restore
        "purchase" -> CtaAction.Purchase
        "request_tracking" -> CtaAction.RequestTracking
        "request_notifications" -> CtaAction.RequestNotifications
        else -> CtaAction.Next
    }

    private fun fromObject(obj: JsonObject): CtaAction {
        return when (obj["type"]?.jsonPrimitive?.content) {
            "url" -> {
                val url = obj["url"]?.jsonPrimitive?.content
                if (url != null) CtaAction.OpenUrl(url = url) else CtaAction.Next
            }
            "screen" -> {
                val screen = obj["screen"]?.jsonPrimitive?.content
                if (screen != null) CtaAction.GoToScreen(screen = screen) else CtaAction.Next
            }
            else -> CtaAction.Next
        }
    }

    private fun CtaAction.toJsonElement() = when (this) {
        is CtaAction.Next -> JsonPrimitive("next")
        is CtaAction.Back -> JsonPrimitive("back")
        is CtaAction.SignIn -> JsonPrimitive("sign_in")
        is CtaAction.Restore -> JsonPrimitive("restore")
        is CtaAction.Purchase -> JsonPrimitive("purchase")
        is CtaAction.RequestTracking -> JsonPrimitive("request_tracking")
        is CtaAction.RequestNotifications -> JsonPrimitive("request_notifications")
        is CtaAction.OpenUrl -> buildJsonObject {
            put("type", "url")
            put("url", url)
        }
        is CtaAction.GoToScreen -> buildJsonObject {
            put("type", "screen")
            put("screen", screen)
        }
    }
}
